<template>
  <div class="passengers-list">
    <ValidationObserver
      ref="observer"
      v-slot="{ handleSubmit, errors, invalid, validated }"
      slim
    >
      <form @submit.prevent="handleSubmit(submitPassengers)">
        <h1 id="wb-cont" class="container">{{ $t("page3title") }}</h1>
        <div
          role="alert"
          v-if="invalid && validated"
          class="alert alert-danger"
        >
          <h4>
            <span class="container">
              <img src="../assets/circle.png" class="error-icon" alt />
              {{ $t("errorSummary", { errCount: countErrors(errors) }) }}
            </span>
          </h4>
          <ul class="container">
            <li
              v-for="(error, index) in realErrors(errors)"
              :key="index"
              v-html="error[0]"
            ></li>
          </ul>
        </div>
        <div class="container" role="list">
          <passengerItem
            v-for="(passengersItem, index) in passengersList"
            :key="passengersItem.name + index"
            v-bind:passengersItem="passengersItem"
            v-bind:index="index"
          />
        </div>
        <div class="form-group text-center mini-widget--actions">
          <a
            href="#"
            class="btn btn-ghost btn-ghost-yellow mrgn-rght-md"
            @click.prevent="modifyTrip"
            >{{ $t("modifytrip") }}</a
          >
          <button type="submit" id="tripNext" class="btn btn-primary">
            {{ $t("next") }}
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import i18n from "../i18n";
import { mapState } from "vuex";
import { ValidationObserver } from "vee-validate";
import passengerItem from "../components/passengerItem.vue";

export default {
  name: "PassengerDetailsList",
  components: {
    ValidationObserver,
    passengerItem,
  },
  data() {
    return {};
  },
  watch: {},
  created() {
    this.$store.commit("getSSRS", this.current_product._id);
    if (this.$store.state.departureTripItem.segments[0].seatMapId) {
      this.$store.commit("getSeatMap");
      if (this.tripType === "roundtrip") {
        this.$store.commit("getReturnSeatMap");
      }
    }
  },
  computed: {
    errorList() {
      const errorList = this.$refs.observer.validate();
      return errorList;
    },
    passengersList() {
      var fareDetails = this.fares;
      var passengerArray = [];
      for (const [key, value] of Object.entries(this.selectedFaresStore)) {
        if (value > 0) {
          const currentType = fareDetails.filter(function (fare) {
            return fare._id == key;
          });
          for (let step = 0; step < value; step++) {
            passengerArray.push({
              name: currentType[0].name,
              fareId: currentType[0]._id,
            });
          }
        }
      }
      return passengerArray;
    },
    ...mapState([
      "current_product",
      "tripType",
      "departureTripItem",
      "returnTripItem",
      "passengers",
      "selectedFaresStore",
      "fares",
    ]),
  },
  methods: {
    modifyTrip: function () {
      this.$router.push("/");
    },
    submitPassengers: function () {
      if (this.passengers && this.departureTripItem.segments[0].seatMapId) {
        this.$router.push("/trips/passengers/seats");
      } else if (this.passengers) {
        this.$store.dispatch("addToCartShowCart").then(() => {
          this.$router.push("/cart");
        });
      } else {
        alert(i18n.t("passenger_info_required"));
      }
    },
    realErrors(obj) {
      for (var propName in obj) {
        if (
          obj[propName] === null ||
          obj[propName] === undefined ||
          !obj[propName].length
        ) {
          delete obj[propName];
        }
      }
      return obj;
    },
    countErrors: function (errors) {
      const errorCount = Object.values(errors);
      let count = 0;
      for (let i = 0; i < errorCount.length; i++) {
        if (errorCount[i].length) {
          count++;
        }
      }
      return count;
    },
  },
  filters: {},
  beforeRouteEnter(to, from, next) {
    if (from.path == "/cart") {
      next("/");
    } else {
      next();
    }
  },
};
</script>
<style lang="scss">
</style>